import { useResponsiveValue } from '@superdispatch/ui';
import { RouterProvider } from 'react-router-dom';
import { SplashScreen } from 'shared/layout/SplashScreen';
import { loadboardMobileRouter, router } from './LoadboardRoutes';

export function LoadboardApp() {
  const isMobile = useResponsiveValue(true, true, false);

  const loadboardRouter = isMobile ? loadboardMobileRouter : router;

  return (
    <RouterProvider
      fallbackElement={<SplashScreen />}
      router={loadboardRouter}
    />
  );
}
